import { SupportedCurrencies } from 'vopay';
import { BillingSecondTab } from './types';

// Asset host for bank / credit-card logo images. Deliberately a shared constant rather than
// host-injected config: every host renders these from the same place.
export const EMBED_ASSETS_HOST = 'https://embed-dev.vopay.com';

// Card records carry no currency of their own: a card is charged in whatever currency the funding
// request asks for, and only CAD card processing is provisioned today, so that is what card rows
// and the billing-default card show. Exported from shared/accountAndBilling so the client portal's
// DefaultFundingMethods reads it here rather than declaring its own copy.
export const CREDIT_CARD_CURRENCY = 'CAD' satisfies SupportedCurrencies;

type I18nLabel = { key: string; defaultValue: string };

/**
 * Everything that varies with the second billing tab, in one place: how the tab is labelled, which
 * downloads its rows offer, and what the statement button says. Label keys are relative to the
 * consumer's keyPrefix: tabLabel resolves under Shared.AccountAndBillingPage, statementLabel under
 * Shared.BillingInvoices. The 'invoiceAndStatement' entry is
 * the client's fused tab and keeps its existing labels, "(CSV)" included; a partner's statement tab
 * downloads a PDF, so its label is format-agnostic.
 */
export const SECOND_TAB_VARIANTS: Record<
  BillingSecondTab,
  {
    tabLabel: I18nLabel;
    hasInvoiceDownload: boolean;
    hasStatementDownload: boolean;
    statementLabel: I18nLabel;
  }
> = {
  invoiceAndStatement: {
    tabLabel: { key: 'Tabs.invoicesAndStatements', defaultValue: 'Invoices & Statements' },
    hasInvoiceDownload: true,
    hasStatementDownload: true,
    statementLabel: { key: 'Table.downloadStatementCSV', defaultValue: 'Download Statement (CSV)' },
  },
  invoice: {
    tabLabel: { key: 'Tabs.invoices', defaultValue: 'Invoices' },
    hasInvoiceDownload: true,
    hasStatementDownload: false,
    statementLabel: { key: 'Table.downloadStatement', defaultValue: 'Download Statement' },
  },
  statement: {
    tabLabel: { key: 'Tabs.statements', defaultValue: 'Statements' },
    hasInvoiceDownload: false,
    hasStatementDownload: true,
    statementLabel: { key: 'Table.downloadStatement', defaultValue: 'Download Statement' },
  },
};
